<template>
  <div id="users">
    <v-container grid-list-xl fluid>
      <header-title title="Usuarios"></header-title>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="showDialog()">
          <v-icon>mdi-plus</v-icon>Nuevo
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="loading"
        :search="search"
        no-data-text="No existen registros"
        no-results-text="Sin resultados"
        item-key="name"
        class="elevation-1"
        v-cloak
      >
        <template v-slot:item.estado="{ item }">
          <td>
            <span v-if="item.estado">
              <v-chip small color="green lighten-4">activo</v-chip>
            </span>
            <span v-else>
              <v-chip small color="red lighten-4">inactivo</v-chip>
            </span>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="success"
                  @click="editItem(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-square-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  color="red"
                  @click="confirmItem(item.id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-close-box</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="mdialog" scrollable max-width="500px">
      <v-form ref="form">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Usuario</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <span class="text--darken-8 grey--text">
              Los campos con
              <b class="red--text">*</b> son requeridos.
            </span>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    label="Instituciones *"
                    :items="instituciones"
                    v-model="user.institucion_id"
                    item-text="descripcion"
                    item-value="id"
                    :rules="[(v) => !!v || 'El campo es requerido']"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    label="Persona *"
                    :items="personas"
                    v-model="user.persona_id"
                    item-text="descripcion"
                    item-value="id"
                    :rules="[(v) => !!v || 'El campo es requerido']"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    type="text"
                    label="Correo electrónico *"
                    v-model="user.correo"
                    :rules="[
                      (v) => !!v || 'El campo es requerido',
                      (v) =>
                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{1,3})+$/.test(v) ||
                        'Debe ser un correo',
                    ]"
                    autocomplete="off"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-if="mode"
                    type="password"
                    label="Contraseña *"
                    v-model="user.clave"
                    :rules="[
                      (v) => !!v || 'El campo es requerido',
                      (v) => (!!v && v.length > 4) || 'Mínimo de 5 dígitos',
                    ]"
                    required
                  >
                  </v-text-field>
                  <v-text-field
                    v-else
                    type="password"
                    label="Contraseña"
                    v-model="user.clave"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Rol *"
                    :items="roles"
                    v-model="user.rol_id"
                    item-text="descripcion"
                    item-value="id"
                    :rules="[(v) => !!v || 'El campo es requerido']"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Estado"
                    :items="states"
                    v-model="user.estado"
                    item-text="descripcion"
                    item-value="id"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              :loading="btn_loading"
              text
              v-show="mode"
              @click.native="createUser()"
              >Guardar</v-btn
            >
            <v-btn
              color="success"
              :loading="btn_loading"
              text
              v-show="!mode"
              @click.native="updateUser()"
              >Actualizar</v-btn
            >
            <v-btn color="red" text @click.native="mdialog = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="mconfirm" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>Esta seguro(a) de eliminar el registro?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :loading="btn_loading"
            text
            @click="deleteItem()"
            >Aceptar</v-btn
          >
          <v-btn color="red" text @click="mconfirm = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top="top"
      right="right"
      rounded="pill"
      :color="snack.color"
      timeout="2500"
      >{{ snack.text }}</v-snackbar
    >
  </div>
</template>
<script>
/* eslint-disable no-console */
import HeaderTitle from "@/components/HeaderTitle";
import Service from "../services/general";
import axios from "axios";
export default {
  name: "users",
  components: {
    HeaderTitle,
  },
  data() {
    return {
      search: "",
      menu: false,
      loading: false,
      btn_loading: false,
      headers: [
        { text: "#", value: "id", align: "left", sortable: false },
        { text: "Institución ", value: "institucion.nombre" },
        { text: "Apellidos y Nombres ", value: "persona.nombre_completo" },
        { text: "Cédula Identidad ", value: "persona.cedula_dni" },
        { text: "Cargo ", value: "rol.descripcion" },
        { text: "Estado ", value: "estado" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      instituciones: [],
      users: [],
      personas: [],
      roles: [],
      user: {
        id: "",
        institucion_id: "",
        persona_id: "",
        correo: "",
        clave: "",
        rol_id: "",
        estado: "activo",
      },
      states: [],
      mdialog: false,
      mconfirm: false,
      mode: true,
      snack: {
        state: false,
        color: "success",
        mode: "",
        timeout: 2500,
        text: "",
      },
    };
  },
  computed: {
    computedDateFormatted() {
      if (!this.user.fecha_nacimiento) return null;

      const [year, month, day] = this.user.fecha_nacimiento.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  mounted() {
    if (Service.getUser()) {
      if (Service.getUser().role == 1) {
        this.personas = Service.getExpedidos();
        this.states = Service.getStates();
        this.getUsers();
        this.getParametros();
      } else {
        this.$router.replace({ name: "dashboard" });
      }
    }
  },
  methods: {
    getUsers() {
      this.loading = true;
      axios
        .get(Service.getBase() + "usuarios", Service.getHeader())
        .then((response) => {
          this.loading = false;
          this.users = response.data;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error al cargar registros", error);
        });
    },
    getParametros() {
      axios
        .get(Service.getBase() + "roles", Service.getHeader())
        .then((response) => {
          this.roles = response.data;
        })
        .catch((error) => {
          console.error("Error al cargar registros", error);
        });
    },
    showDialog() {
      this.mode = true;
      this.user = {
        id: "",
        institucion_id: "",
        persona_id: "",
        correo: "",
        clave: "",
        rol_id: "",
        estado: true,
        cambia_clave: false,
      };
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.mdialog = true;
    },
    createUser() {
      if (this.$refs.form.validate()) {
        this.btn_loading = true;
        axios
          .post(Service.getBase() + "usuario", this.user, Service.getHeader())
          .then(() => {
            this.btn_loading = false;
            this.toast("success", "Registro guardado");
            this.mdialog = false;
            this.getUsers();
          })
          .catch(() => {
            this.btn_loading = false;
            console.error("Error al guardar");
          });
      }
    },

    editItem(data) {
      this.mode = false;
      this.user = data;
      this.mdialog = true;
    },

    updateUser() {
      if (this.$refs.form.validate()) {
        this.btn_loading = true;
        axios
          .put(
            Service.getBase() + "usuario/" + this.user.id,
            this.user,
            Service.getHeader()
          )
          .then(() => {
            this.btn_loading = false;
            this.toast("success", "Registro actualizado");
            this.mdialog = false;
            this.getUsers();
          })
          .catch(() => {
            this.btn_loading = false;
            this.toast("error", "No se pudo actualizar");
            console.error("Error al actualizar");
          });
      }
    },

    confirmItem(id) {
      this.user.id = id;
      this.mconfirm = true;
    },

    deleteItem() {
      this.btn_loading = true;
      axios
        .delete(
          Service.getBase() + "usuario/" + this.user.id,
          Service.getHeader()
        )
        .then(() => {
          this.btn_loading = false;
          this.toast("success", "Registro eliminado");
          this.mconfirm = false;
          this.getUsers();
        })
        .catch(() => {
          this.btn_loading = false;
          this.toast("error", "Registro en uso o no existente");
        });
    },

    toast(mcolor, mtext) {
      this.snack.color = mcolor;
      this.snack.text = mtext;
      this.snack.state = true;
    },
  },
};
</script>
